import React, { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  IconButton,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import StoreIcon from "@mui/icons-material/Store";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { Stack } from "react-bootstrap";
import moment from "moment";
import ItemWiseModal from "./ItemWiseModal";
import LocationAndItemWiseModal from "./LocationAndItemWiseModal";
import LocationWiseModal from "./LocationWiseModal";
import {
  CmpStatusIconV1,
  CmpStatusIconV2,
  CmpStatusIconV3,
} from "../../../Component/Common/ToolBox/ToolBox";

const CardSummary = ({
  data = [],
  onClick = () => {},
  onClickNext = () => {},
}) => {
    const vMediaQuery = useMediaQuery("(max-width:650px)");
  const [openViewModal, setOpenViewModal] = useState(false);
  // const [openLocationModal, setOpenLocationModal] = useState(false);
  const [openLocationItemModal, setOpenLocationItemModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [openLocationModal, setOpenLocationModal] = useState(false);

  return (
    <Grid container spacing={2} marginTop={2}>
      {data.map((item, index) => (
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          lg={3}
          key={index}
          onClick={() => {
            // let items = { row: item };
            // onClick(items);
          }}
        >
          <Card
            sx={{
              borderRadius: 3,
              boxShadow: 3,
              "& .MuiCardContent-root": {
                padding: "0px !important",
              },
            }}
          >
            <CardContent>
              <Box sx={{ backgroundColor: "#FAF9F6", p: 1.5 }}>
                {/* Name and Position */}
                <Grid container>
                  <Grid item xs={11}>
                    <Typography variant="h6" fontWeight="bold">
                      {item.A_VocNo}
                    </Typography>
                    <Typography variant="subtitle2" color="gray">
                      {moment(item.A_VocDt).format("DD/MM/YYYY")}
                    </Typography>
                  </Grid>
                  {/* <Grid item xs={1} textAlign={'right'}>
                    <CmpStatusIconV2 xStatus={item.Status}  />
                  </Grid> */}
                  <Grid item xs={1} textAlign={'right'}>
                    <CmpStatusIconV3 xStatus={item?.Indicator}  />
                  </Grid>
                </Grid>
              </Box>
              <Box
                display="flex"
                justifyContent={"space-between"}
                paddingX={1.5}
              >
                <Typography variant="body2" color="primary" marginTop={vMediaQuery ? 0.5:1}>
                  <strong> Segregation:</strong> {item.SegregationMethod}
                </Typography>
                <Stack direction="row" spacing={4}>
                  <Tooltip
                    title="View"
                    placement="top"
                    sx={{ margin: 0 }}
                    componentsProps={{
                      tooltip: {
                        sx: { margin: "0px !important", padding: "2px 6px" },
                      }, // Reduce padding in tooltip
                    }}
                  >
                    <IconButton
                      sx={{ padding: "5px", margin: "2px" }}
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent triggering onClick of Grid
                        setSelectedItem(item);
                        setOpenViewModal(true);
                      }}
                    >
                      <VisibilityIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip
                    title="Location"
                    placement="top"
                    sx={{ margin: 0 }}
                    componentsProps={{
                      tooltip: {
                        sx: { margin: "0px !important", padding: "2px 6px" },
                      }, // Reduce padding in tooltip
                    }}
                  >
                    <IconButton
                      sx={{ padding: "5px", margin: "2px" }}
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent triggering onClick of Grid
                        setSelectedItem(item);
                        setOpenLocationItemModal(true);
                      }}
                    >
                      <StoreIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip
                    title="New"
                    placement="top"
                    sx={{ margin: 0 }}
                    componentsProps={{
                      tooltip: {
                        sx: { margin: "0px !important", padding: "2px 6px" },
                      }, // Reduce padding in tooltip
                    }}
                  >
                    <IconButton
                      sx={{ padding: "5px", margin: "2px" }}
                      onClick={(e) => {
                        let items = { row: item };
                        onClick(items);
                        e.stopPropagation(); // Prevent triggering onClick of Grid
                        setSelectedItem(item);
                        // setOpenLocationModal(true);
                        onClickNext()
                      }}
                    >
                      <AddCircleIcon />
                    </IconButton>
                  </Tooltip>
                </Stack>
              </Box>

              <Grid container spacing={1} p={1.5}>
                {/* <Grid item xs={6}>
                  <Grid container>
                    <Grid item xs={5.7} md={4.6}>
                      <Typography variant="body2" component="span">
                        Drop.ID
                      </Typography>
                    </Grid>
                    <Grid item xs={0.5} md={0.5}>
                      <Typography variant="body2" component="span">
                        :
                      </Typography>
                    </Grid>
                    <Grid item xs={5.8} md={6.9}>
                      <Typography variant="body2">{item.L_DropID}</Typography>
                    </Grid>
                  </Grid>
                </Grid> */}
                <Grid item xs={6}>
                  <Grid container>
                    <Grid item xs={5.7} md={4.6}>
                      <Typography variant="body2" component="span">
                        Qty
                      </Typography>
                    </Grid>
                    <Grid item xs={0.5} md={0.5}>
                      <Typography variant="body2" component="span">
                        :
                      </Typography>
                    </Grid>
                    <Grid item xs={5.8} md={6.9}>
                      <Typography variant="body2"> {item.L_BaseQty}</Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={6}>
                  <Grid container>
                    <Grid item xs={5.7} md={4.6}>
                      <Typography variant="body2" component="span">
                        Picked
                      </Typography>
                    </Grid>
                    <Grid item xs={0.5} md={0.5}>
                      <Typography variant="body2" component="span">
                        :
                      </Typography>
                    </Grid>
                    <Grid item xs={5.8} md={6.9} component="span">
                      <Typography variant="body2">
                        {(item.TotalPickedQty).toFixed(0)}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={6}>
                  <Grid container>
                    <Grid item xs={5.7} md={4.8}>
                      <Typography variant="body2" component="span">
                         %
                      </Typography>
                    </Grid>
                    <Grid item xs={0.5} md={0.5}>
                      <Typography variant="body2" component="span">
                        :
                      </Typography>
                    </Grid>
                    <Grid item xs={5.8} md={6.7}>
                      <Typography variant="body2" component="span">
                        {" "}
                        {item.CompletionPercentage.toFixed(2)} 
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      ))}

      <ItemWiseModal
        open={openViewModal}
        handleClose={() => {
          setOpenViewModal(false);
          setSelectedItem(null);
        }}
        data={selectedItem}
        selectedItem={selectedItem}
        vMediaQuery={vMediaQuery}
      />
      <LocationWiseModal
        open={openLocationModal}
        handleClose={() => {
          setOpenLocationModal(false);
          setSelectedItem(null);
        }}
        data={selectedItem}
        selectedItem={selectedItem}
        xOnClick={onClickNext}
        vMediaQuery={vMediaQuery}
      />
      <LocationAndItemWiseModal
        open={openLocationItemModal}
        handleClose={() => {
          setOpenLocationItemModal(false);
          setSelectedItem(null);
        }}
        data={selectedItem}
        selectedItem={selectedItem}
        vMediaQuery={vMediaQuery}
      />
    </Grid>
  );
};

export default CardSummary;
